//@flow
import * as Immutable from 'immutable';

import { IntelliSortRequest } from 'common/models/flow/IntelliSortRequest';

import type { IntelliSortRequestModelType } from 'common/models/flow/IntelliSortRequest';

import { AutoSortRequest } from 'common/models/internal/AutoSortRequest';
import { AutoSortResponse } from 'common/models/internal/AutoSortResponse';
import { GeocodedLocation } from 'common/models/internal/GeocodedLocation';
import { VersionedMapId } from 'common/models/internal/VersionedMapId';
import { IntelliSortFeedback } from 'common/models/internal/IntelliSortFeedback';
import { ZoneBasedRoutingMetadata } from 'common/models/internal/ZoneBasedRoutingMetadata';

import EntityTypeEnum from 'common/enums/EntityTypeEnum';

export const FeedbackStatusType = new EntityTypeEnum({
    Null: 'WAITING',
    Correct: 'ACCEPTED',
    Incorrect: 'REJECTED'
});

export const ResponseLayerType = new EntityTypeEnum({
    GEOCODE_BASED: 'GEOCODE_BASED',
    LOCALITY_BASED: 'LOCALITY_BASED',
    PINCODE_BASED: 'PINCODE_BASED',
    LEARNING_BASED: 'LEARNING_BASED'
});

export const ResponseSourceType = new EntityTypeEnum({
    GEOCODING: 'GEOCODING',
    TEXT_SEARCH: 'TEXT_SEARCH',
    NEARBY_SEARCH: 'NEARBY_SEARCH',
    FIND_PLACES: 'FIND_PLACES',
    DATABASE_SEARCH: 'DATABASE_SEARCH',
    LEARNING_SEARCH: 'LEARNING_SEARCH',
    REPEAT_SEARCH: 'REPEAT_SEARCH',
    CENTER_OF_LOCALITY: 'CENTER_OF_LOCALITY',
    CENTER_OF_CITY: 'CENTER_OF_CITY',
    CENTRE_OF_PINCODE: 'CENTRE_OF_PINCODE',
    CENTRE_OF_COUNTRY: 'CENTRE_OF_COUNTRY'
});

class InternalIntelliSortRequest extends IntelliSortRequest {
    static fromJS(
        json: IntelliSortRequestModelType
    ): InternalIntelliSortRequest {
        const state: Object = Object.assign({}, json);
        state.request = AutoSortRequest.fromJS(state.request);
        state.response = AutoSortResponse.fromJS(state.response);
        state.geocodedLocation = GeocodedLocation.fromJS(
            state.geocodedLocation
        );
        state.allowedRouteIds = Immutable.List(state.allowedRouteIds);
        state.versionedMapIds = Immutable.List(
            state.versionedMapIds
        ).map(item => VersionedMapId.fromJS(item));
        state.feedback = IntelliSortFeedback.fromJS(state.feedback);
        state.zoneBasedRoutingMetadata = ZoneBasedRoutingMetadata.fromJS(
            state.zoneBasedRoutingMetadata
        );
        return new this(Immutable.Map(state));
    }

    get request(): AutoSortRequest {
        return this._state.get('request');
    }

    get response(): AutoSortResponse {
        return this._state.get('response');
    }

    get geocodedLocation(): GeocodedLocation {
        return this._state.get('geocodedLocation');
    }

    get versionedMapIds(): Immutable.List<VersionedMapId> {
        return this._state.get('versionedMapIds');
    }

    get feedback(): IntelliSortFeedback {
        return this._state.get('feedback');
    }
}

export { InternalIntelliSortRequest as IntelliSortRequest };
